export class TemperatureMeasurementLoadCompleted {
}
